import { transactionCollection } from "../../config/collectionsConfig";

export const GetTransactions = () => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    // make async call to the database
    try {
      dispatch({ type: "LOAD_TRANSACTIONS" });
      const firestore = getFirestore();
      firestore
        .collection(transactionCollection)
        .where("specificType", "in", [1, 3, 5, 6])
        .where("status", "==", 2)
        .where("reciever", "==", getState().profile.profile.id)
        .orderBy("timestamp", "desc")
        .get()
        .then((dests) => {
          const transactions = [];
          dests.forEach((ds) => {
            transactions.push({ ...ds.data(), id: ds.id });
          });
          firestore
            .collection(transactionCollection)
            .where("specificType", "==", 3)
            .where("sender", "==", getState().profile.profile.id)
            .orderBy("timestamp", "desc")
            .get()
            .then((xdests) => {
              xdests.forEach((ds) => {
                transactions.push({ ...ds.data(), id: ds.id });
              });
              dispatch({
                type: "GET_TRANSACTIONS",
                payload: transactions,
              });
            })
            .catch((e) => {
              dispatch({ type: "GET_TRANSACTIONS_ERROR", payload: e });
            });
        })
        .catch((e) => {
          dispatch({ type: "GET_TRANSACTIONS_ERROR", payload: e });
        });
    } catch (e) {
      dispatch({ type: "GET_TRANSACTIONS_ERROR", payload: e });
    }
  };
};
